/**
 * How long after making a session token on the client side until it expires
 */
export const SESSION_TOKEN_EXPIRATION_HOURS = 24 * 7 // 7 days

export const USER_TRIAL_DAYS_ACTIVE_THRESHOLD = 3

export const FREE_TRIAL_DAYS = 3
